import CryptoJS from 'crypto-js';

const DEFAULT_KEY = '909DentalOpdSecureKey2026Secret!'; // 32 characters
const DEFAULT_IV = '909DentalOpdInit'; // 16 characters

/**
 * Get secret key and IV formatted for CryptoJS
 */
const getKeyAndIV = () => {
  const rawKey = (process.env.REACT_APP_ENCRYPTION_KEY || DEFAULT_KEY).padEnd(32, '0').slice(0, 32);
  const rawIV = (process.env.REACT_APP_ENCRYPTION_IV || DEFAULT_IV).padEnd(16, '0').slice(0, 16);

  const key = CryptoJS.enc.Utf8.parse(rawKey);
  const iv = CryptoJS.enc.Utf8.parse(rawIV);
  return { key, iv };
};

/**
 * Encrypt any data payload to AES-256-CBC Base64 string
 * @param {any} data - Object, array, string, number
 * @returns {string} Base64 encrypted cipher string
 */
export const encryptData = (data) => {
  if (data === undefined || data === null) return data;
  try {
    const text = typeof data === 'object' ? JSON.stringify(data) : String(data);
    const { key, iv } = getKeyAndIV();

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  } catch (error) {
    console.error('Payload encryption error:', error);
    return data;
  }
};

/**
 * Decrypt AES-256-CBC Base64 cipher string to original data
 * @param {string} cipherText - Base64 encrypted cipher string
 * @returns {any} Decrypted object or original string
 */
export const decryptData = (cipherText) => {
  if (!cipherText || typeof cipherText !== 'string') return cipherText;
  try {
    const { key, iv } = getKeyAndIV();

    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    if (!decryptedText) return cipherText;

    try {
      return JSON.parse(decryptedText);
    } catch {
      return decryptedText;
    }
  } catch (error) {
    console.error('Payload decryption error:', error);
    return cipherText;
  }
};

export default {
  encryptData,
  decryptData,
};
